/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedIconBubbleEmail_user = {
    readonly profile: {
        readonly email: string | null;
    } | null;
    readonly " $refType": "PdpSharedIconBubbleEmail_user";
};
export type PdpSharedIconBubbleEmail_user$data = PdpSharedIconBubbleEmail_user;
export type PdpSharedIconBubbleEmail_user$key = {
    readonly " $data"?: PdpSharedIconBubbleEmail_user$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedIconBubbleEmail_user">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpSharedIconBubbleEmail_user",
  "type": "User",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "profile",
      "storageKey": null,
      "args": null,
      "concreteType": "Profile",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "email",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
};
(node as any).hash = '96e6b4733ec67b07b621e74786faffd4';
export default node;
